import styled from "styled-components";

const FeaturesCardStyleWrapper = styled.article`
  background: rgba(255, 255, 255, 0.05);
  width: 100%;
  min-height: 220px;
  padding: 35px;
  border-radius: 10px;

  img {
    margin-bottom: 20px;
    height: 100%;
    width: 100%;
  }

  h3 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 40px;
    color: #ffffff;
    text-align: center;

    span {
      margin-right: 13px;
    }
  }

  p {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 28px;
    margin-bottom: 0;
    text-align: center;
  }

  @media only screen and (min-width: 992px) and (max-width: 1199px) {
    h3 {
      font-size: 19px;
      line-height: 40px;

      span {
        max-width: 40px;
      }
    }
  }

  @media only screen and (min-width: 768px) and (max-width: 991px) {
    padding: 27px;
    h3 {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;
      font-size: 18px;
      line-height: 30px;
    }
  }

  @media only screen and (max-width: 767px) {
    p {
      max-width: 100%;
    }
  }

  @media (max-width: 375px) {
    padding: 30px;
    h3 {
      font-size: 20px;
      line-height: 40px;

      span {
        max-width: 40px;
      }
    }
  }
`;

export default FeaturesCardStyleWrapper;
